import { render } from "./blockIcon.vue?vue&type=template&id=4b552233&scoped=true"
import script from "./blockIcon.vue?vue&type=script&lang=js"
export * from "./blockIcon.vue?vue&type=script&lang=js"

import "./blockIcon.vue?vue&type=style&index=0&id=4b552233&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b552233"]])

export default __exports__